export default __webpack_public_path__ + "static/media/landing-calendar-perview.d16445fc.png";